<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED, MODULE } from "@/constants";
import { mapState } from "vuex";
import { RISK_STATUS_MODULE } from '@/state/modules/riskStatus'
import { riskStatusMethods } from "@/state/helpers";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.riskStatus')]),
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'Risk-status-update' && to.name != 'Risk-status-create') {
            sessionHelper.clearSearch(SESSION.RISK_STATUS_SEARCH)
        }
        next();
    },
    async created() {
        await this.validPermissions();
        this.initSearchCriteria();
    },
    components: { Layout, PageHeader },
    data() {
        return {
            module: MODULE.RISK_STATUS,
            title: i18n.t("label.listingX", [i18n.t('module.riskStatus')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.riskStatus"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            accountLockStatusDdl: ddlHelper.getAccountLockStatus(true),
            currentUser: sessionHelper.getUserEmail(),
            currentPage: 1,
            filter: "",
            enabled: false,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            pageOptions: [10, 25, 50, 100],
            filterOn: [],
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            updatePermission: null,
            updateStatusPermission: null,
            readPermission: null,
            sortBy: "name",
            fields: [
                { key: "name", sortable: true, label: i18n.t("label.name"), },
                { key: "isActive", sortable: true, label: i18n.t("label.status") },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
        };
    },
    computed: {
        ...mapState(RISK_STATUS_MODULE, ['status']),
        tableRows() {
            return this.$store.state.riskStatus.list.data;
        },
        pagination() {
            return this.$store.state.riskStatus.list.pagination;
        },
        totalPage() {
            return this.$store.state.riskStatus.list.pagination.total;
        },
    },
    mounted() { },
    methods: {
        ...riskStatusMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_RS_RSC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_RS_RSR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_RS_RSU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_RS_RSUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }
        },
        initSearchCriteria() {
            let isDefault = true;

            if (sessionHelper.hasSearchCriteria(SESSION.RISK_STATUS_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.RISK_STATUS_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber; 
            }

            if (isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.statusDdl[0].value,
                    isLocked: this.accountLockStatusDdl[0].value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            if (this.readPermission == true) {
            this.getStatusList(this.searchCriteria);
            }
        },

        getStatusList(filter) {
            this.getAllRisks({ filter });
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.RISK_STATUS_SEARCH, filter);
        },

        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.RISK_STATUS_SEARCH);
            filter.pageNumber = pageNumber;

            this.getStatusList(filter);
        },

        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if(this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1; 
                this.currentPage = 1;
            }
            this.getStatusList(this.searchCriteria);
        },

        editStatus(printerProof) {
            const data = {
                id: printerProof.uuid,
                isActive: printerProof.isActive,
            };

            this.updateRiskStatus({ filter: this.searchCriteria, data });
        },

        toDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.RISK_STATUS_SEARCH)
            filter.selectedRecordId = id
            sessionHelper.storeSearch(SESSION.RISK_STATUS_SEARCH, filter)

            this.$router.push({
                name: 'Risk-status-update', // Name of the route
                query: {
                    module: MODULE.RISK_STATUS,
                }
            });
        },

    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                    style="float: left">
                                    <label class="d-inline-flex align-items-center">
                                        {{ $t("label.search") }}
                                        <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                                            class="form-control form-control-sm ml-2"
                                            @change="searchListing"></b-form-input>
                                    </label>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                    style="float: right">
                                    <router-link tag="a" :to="'/risk-status/create?module=' + module"  v-if="createPermission == true"
                                        style="float: right; margin-bottom: 10px"
                                        class="btn btn-primary w-md waves-effect waves-light">
                                        {{ $t('label.createX', [$t('module.riskStatus')]) }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage" v-if="this.readPermission == true">
                                <template #cell(isActive)="data">
                                    <b-form-checkbox @change="editStatus(tableRows[data.index])"
                                        v-model="tableRows[data.index].isActive" switch class="mb-1"
                                        :disabled="updateStatusPermission == false">
                                    </b-form-checkbox>
                                </template>

                                <template #cell(isLocked)="data">
                                    <span v-if="tableRows[data.index].isLocked == true">{{ $t('label.lock') }}</span>
                                    <span v-else>{{ $t('label.active') }}</span>
                                </template>

                                <template #cell(action)="data">
                                    <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                        ? 'disabled text-warning'
                                        : 'text-primary'
                                        " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                        v-if="readPermission == true && updatePermission == true" title="Edit">
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>

                                    <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                        ? 'disabled text-warning'
                                        : 'text-primary'
                                        " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                        style="margin-left: 5px;"
                                        v-if="readPermission == true && updatePermission != true" title="Read">
                                        <i class="mdi mdi-file-search-outline font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div style="text-align: center;" v-else>
                                {{ $t('message.noPermissionMessage') }}
                            </div>
                        </div>
                        <div class="row" v-if="this.readPermission == true">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                                            @change="pageNavigation"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
a.disabled {
    pointer-events: none;
    cursor: default;
}
</style>